export const PRVOLT_ORGANIZATION_ID = process.env.PRVOLT_ORGANIZATION_ID || 1;

export const isPRVoltOrganization = org => org === PRVOLT_ORGANIZATION_ID;
